import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import Layout from './components/Layout/Layout';
import Home from './components/Home/Home';
import Entreprises from './components/Entreprises/Entreprises';
import EntrepriseDetail from './components/Entreprises/EntrepriseDetail';
import Etudiants from './components/Etudiants/Etudiants';
import Offres from './components/Offres/Offres';
import NotFound from './components/NotFound/NotFound';
import Login from './components/Login/Login';
import Admin from './components/Admin/Admin';
import Wishlist from './components/Wishlist/Wishlist';
import Candidatures from './components/Candidatures/Candidatures';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRouteComponent from './components/PrivateRoute/PrivateRoute';
import theme from './theme';
import { ROLES } from './utils/roles';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import NewEntreprise from './components/Entreprises/NewEntreprise';
import EditEntreprise from './components/Entreprises/EditEntreprise';
import NewOffre from './components/Offres/NewOffre';
import EditOffre from './components/Offres/EditOffre';
import Pilotes from './components/Pilotes/Pilotes';
import NewPilote from './components/Pilotes/NewPilote';
import EditPilote from './components/Pilotes/EditPilote';
import NewEtudiant from './components/Etudiants/NewEtudiant';
import EditEtudiant from './components/Etudiants/EditEtudiant';
import OffreDetails from './components/Offres/OffreDetails';
import LegalNotice from './components/Legal/LegalNotice';
import Sitemap from './components/Sitemap/Sitemap';
import Profile from './components/Profile/Profile';
import Stats from './components/Stats/Stats';
import SuiviStage from './components/Etudiants/SuiviStage';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="entreprises" element={<Entreprises />} />
              <Route path="entreprises/:id" element={<EntrepriseDetail />} />
              <Route path="etudiants" element={
                <PrivateRouteComponent requiredRole={[ROLES.ADMIN, ROLES.PILOTE]}>
                  <Etudiants />
                </PrivateRouteComponent>
              } />
              <Route path="offres" element={<Offres />} />
              <Route path="offres/:id" element={<OffreDetails />} />
              <Route path="admin" element={
                <PrivateRouteComponent requiredRole={ROLES.ADMIN}>
                  <Admin />
                </PrivateRouteComponent>
              } />
              <Route path="wishlist" element={
                <PrivateRouteComponent requiredRole={ROLES.ETUDIANT}>
                  <Wishlist />
                </PrivateRouteComponent>
              } />
              <Route path="candidatures" element={
                <PrivateRouteComponent requiredRole={ROLES.ETUDIANT}>
                  <Candidatures />
                </PrivateRouteComponent>
              } />
              <Route path="entreprises/new" element={
                <PrivateRouteComponent requiredRole={[ROLES.ADMIN, ROLES.PILOTE]}>
                  <NewEntreprise />
                </PrivateRouteComponent>
              } />
              <Route path="entreprises/:id/edit" element={
                <PrivateRouteComponent requiredRole={[ROLES.ADMIN, ROLES.PILOTE]}>
                  <EditEntreprise />
                </PrivateRouteComponent>
              } />
              <Route path="offres/new" element={
                <PrivateRouteComponent requiredRole={[ROLES.ADMIN, ROLES.PILOTE]}>
                  <NewOffre />
                </PrivateRouteComponent>
              } />
              <Route path="offres/:id/edit" element={
                <PrivateRouteComponent requiredRole={[ROLES.ADMIN, ROLES.PILOTE]}>
                  <EditOffre />
                </PrivateRouteComponent>
              } />
              <Route path="pilotes" element={
                <PrivateRouteComponent requiredRole={[ROLES.ADMIN]}>
                  <Pilotes />
                </PrivateRouteComponent>
              } />
              <Route path="pilotes/new" element={
                <PrivateRouteComponent requiredRole={[ROLES.ADMIN]}>
                  <NewPilote />
                </PrivateRouteComponent>
              } />
              <Route path="pilotes/:id/edit" element={
                <PrivateRouteComponent requiredRole={[ROLES.ADMIN]}>
                  <EditPilote />
                </PrivateRouteComponent>
              } />
              <Route path="etudiants/new" element={
                <PrivateRouteComponent requiredRole={[ROLES.ADMIN, ROLES.PILOTE]}>
                  <NewEtudiant />
                </PrivateRouteComponent>
              } />
              <Route path="etudiants/:id/edit" element={
                <PrivateRouteComponent requiredRole={[ROLES.ADMIN, ROLES.PILOTE]}>
                  <EditEtudiant />
                </PrivateRouteComponent>
              } />
              <Route path="etudiants/:id/suivi" element={
                <PrivateRouteComponent requiredRole={[ROLES.ADMIN, ROLES.PILOTE]}>
                  <SuiviStage />
                </PrivateRouteComponent>
              } />
              <Route path="mentions-legales" element={<LegalNotice />} />
              <Route path="plan-du-site" element={<Sitemap />} />
              <Route path="profil" element={
                <PrivateRouteComponent requiredRole={[ROLES.ETUDIANT, ROLES.PILOTE]}>
                  <Profile />
                </PrivateRouteComponent>
              } />
              <Route path="stats" element={<Stats />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
